import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileAlt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.025 1.725L19.275 6.975C19.4231 7.10869 19.5054 7.30052 19.5 7.5V21C19.5 21.8284 18.8284 22.5 18 22.5H6C5.17157 22.5 4.5 21.8284 4.5 21V3C4.5 2.17158 5.17157 1.5 6 1.5H13.5C13.6995 1.49465 13.8913 1.57686 14.025 1.725ZM8.25 13.5V12H15.75V13.5H8.25ZM8.25 18V16.5H15.75V18H8.25ZM13.5 3.29999L17.7 7.49999H13.5V3.29999ZM6 21H18V9.00002H13.5C12.6716 9.00002 12 8.32845 12 7.50002V3.00002H6V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileAlt.vue"]]);
